<section class="institutional">
  <div class="institutional-header">
    <h1 class="institutional-header__title">Termos de uso</h1>
  </div>
  <div class="institutional-content">
    <div class="text">
      <div class="text-section">
        <h3>1 DO OBJETO</h3>
        <p>
          1.1 Estes Termos e Condições de Uso, doravante denominados apenas
          “Termos”, aplicam-se aos usuários optantes pelo cadastro e utilização
          dos serviços de intermediação de transportes, por meio de ambiente
          virtual (plataforma) e aplicativo IMMOBILE.
        </p>
        <p>
          1.2 O IMMOBILE é uma plataforma para pesquisa de imóveis, com
          facilitação de entrar em contato com a imobiliária
        </p>
      </div>
      <div class="text-section">
        <h3>2 DO CADASTRO E DA CIÊNCIA DOS TERMOS</h3>
        <p>
          2.1 Ao se cadastrar junto ao aplicativo IMMOBILE, ao usuário serão
          apresentados os presentes Termos e também a Política de Privacidade.
          Ao aceitá- los, o usuário declara ter lido e estar ciente de todo o
          seu conteúdo, firmando o compromisso de cumprir com rigor todas as
          condições estabelecidas.
        </p>
        <p>
          2.2 Os presentes Termos, assim também a Política de Privacidade,
          poderão, a qualquer momento, ser alterados/atualizados, sem a
          necessidade de prévio aviso, mas imediatamente disponibilizados na
          plataforma, sendo de responsabilidade exclusiva do motorista a leitura
          periódica deles.
        </p>
        <p>
          2.3 Presumem-se aceitos os Termos eventualmente alterados/atualizados,
          se após a sua publicação na plataforma o usuário permanecer utilizando
          o aplicativo.
        </p>
        <p>
          2.4 Se o usuário discordar das alterações ou novos Termos, assim
          também quanto a Política de Privacidade, deverá requerer o
          cancelamento da sua conta junto ao aplicativo IMMOBILE, o que o
          excluirá da aplicação tecnológica.
        </p>
        <p>
          2.5 O usuário está ciente que os dados por ele fornecidos estão
          sujeitos ao tratamento de dados disposto na Política de Privacidade,
          que faz parte dos presentes Termos.
        </p>
        <p>
          2.6 O usuário está ciente que o IMMOBILE não tem qualquer acesso ao
          login de usuário, de modo que as informações cadastrais (assim também
          dos motoristas) são as inscritas pelo próprio no momento do cadastro.
        </p>
        <p>
          2.7 O usuário responsabiliza-se civil e criminalmente pelas
          informações por ele cadastradas, sendo sua obrigação mantê-las sempre
          válidas e atualizadas, sob pena de cancelamento do acesso, a critério
          exclusivo do IMMOBILE.
        </p>
        <p>
          2.8 No aplicativo IMMOBILE o usuário terá acesso, após login, ao seu
          perfil e favoritos
        </p>
      </div>
      <div class="text-section">
        <h3>3 DO ACESSO</h3>
        <p>
          4.1 O acesso à conta do aplicativo IMMOBILE se dá mediante a inserção
          de login e senha, sendo esta pessoal e intransferível,
          comprometendo-se o usuário a não compartilhar a sua conta com
          terceiros, sob pena de imediato cancelamento do acesso e, se
          necessário, a comunicação dos fatos às autoridades competentes para a
          tomada das medidas cabíveis.
        </p>
        <p>
          4.2 O usuário se compromete, sob as penas da lei, a utilizar o
          IMMOBILE de forma lícita e no mais estrito cumprimento dos presentes
          Termos.
        </p>
        <p>
          4.3 O IMMOBILE não se responsabiliza por quaisquer danos sofridos pelo
          usuário em decorrência da má utilização, ou utilização de má-fé, do
          aplicativo.
        </p>
      </div>
      <div class="text-section">
        <h3>5 DA SUSPENSÃO E CANCELAMENTO DA CONTA DE USUÁRIO</h3>
        <p>
          5.1 O IMMOBILE poderá, a seu livre critério, suspender o acesso ou
          cancelar a conta de usuário nos casos, e não somente nestes, de:
        </p>
        <p>a) descumprimento pelo usuário dos presentes Termos;</p>
        <p>b) má conduta, configurada pelas avaliações dos motoristas;</p>
        <p>
          c) ordem judicial ou determinação administrativa das autoridades
          públicas;
        </p>
        <p>d) inatividade prolongada da conta;</p>
        <p>
          e) não atendimento a quaisquer requisições do IMMOBILE de atualização
          ou complementaçã o de cadastro;
        </p>
        <p>f) conduta ilícita do usuário ou contrária à boa-fé;</p>
        <p>
          g) inadimplemento por parte do usuário de quaisquer obrigações
          decorrentes da intermediação;
        </p>
        <p>g) por requisição do próprio usuário;</p>
        <p>
          5.2 O usuário está ciente que a suspensão ou exclusão da sua conta de
          usuário, por qualquer razão, prescinde de prévia notificação, não
          tendo direito a qualquer indenização, bem como não o isentando do
          pagamento de eventuais valores devidos ao IMMOBILE, os quais poderão,
          a critério deste, ser cobrados judicial ou extrajudicialmente.
        </p>
      </div>
      <div class="text-section">
        <h3>6 DO PRAZO DE VIGÊNCIA</h3>
        <p>
          6.1 A vigência dos presentes Termos se inicia com o aceite do usuário
          aos Termos e também à Política de Privacidade, e vigora por prazo
          indeterminado, ressalvada a opção de qualquer das partes pela
          rescisão.
        </p>
      </div>
      <div class="text-section">
        <h3>7 DO FORO</h3>
        <p>
          7.1 Para dirimir quaisquer dúvidas e questões oriundas dos presentes
          Termos, fica eleito o foro da Comarca de Caxias do Sul/RS, que exclui
          qualquer outro, por mais privilegiado que seja.
        </p>
      </div>
    </div>
  </div>
</section>
